// Smoothed camera follow.
//
// GDD §14.6: critically damped follow (no overshoot, no jitter). MVP uses a
// simple exponential smoothing — good enough for single-player preview, can
// be upgraded to a proper critically damped spring post-MVP.

import type { Container } from 'pixi.js';

export interface Camera {
  x: number;
  y: number;
  /** Pixels per world unit. */
  scale: number;
}

export function createCamera(): Camera {
  return { x: 0, y: 0, scale: 1 };
}

export function updateCamera(
  camera: Camera,
  targetX: number,
  targetY: number,
  _velocityX: number,
  _velocityY: number,
  dt: number,
): Camera {
  if (dt <= 0) {
    return { ...camera, x: targetX, y: targetY };
  }
  // Exponential smoothing toward target. k≈0.15/frame at 60fps feels tight.
  const k = Math.min(1, dt * 8);
  return {
    ...camera,
    x: camera.x + (targetX - camera.x) * k,
    y: camera.y + (targetY - camera.y) * k,
  };
}

export function applyCameraToLayer(camera: Camera, layer: Container): void {
  const cx = window.innerWidth / 2;
  const cy = window.innerHeight / 2;
  layer.position.set(cx - camera.x * camera.scale, cy - camera.y * camera.scale);
  layer.scale.set(camera.scale);
}
